export const revalidate = process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? 60 : 1;

// determine publication mode. If true publish domain page at root rather than index file.
export const publishMode = process.env.NEXT_PUBLIC_PUBLISHED === 'true';
export const domain = process.env.NEXT_PUBLIC_PUBLISHED_DOMAIN_ID;

export const fallback = 'blocking';
